/* tslint:disable */
/* eslint-disable */
/**
 * TOM OPERATIONS SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { IssueDto } from '../model'
/**
 * IssuesApi - axios parameter creator
 */
export const IssuesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Issues`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} carrierVisitId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getByCarrierVisitId: async (
      carrierVisitId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'carrierVisitId' is not null or undefined
      assertParamExists('getByCarrierVisitId', 'carrierVisitId', carrierVisitId)
      const localVarPath = `/operations/api/Issues/carrier/{carrierVisitId}`.replace(
        `{${'carrierVisitId'}}`,
        encodeURIComponent(String(carrierVisitId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * IssuesApi - functional programming interface
 */
export const IssuesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = IssuesApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAll(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IssueDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssuesApi.getAll']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} carrierVisitId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getByCarrierVisitId(
      carrierVisitId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IssueDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getByCarrierVisitId(
        carrierVisitId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssuesApi.getByCarrierVisitId']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * IssuesApi - factory interface
 */
export const IssuesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = IssuesApiFp(configuration)
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<IssueDto>> {
      return localVarFp.getAll(options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} carrierVisitId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getByCarrierVisitId(
      carrierVisitId: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<IssueDto>> {
      return localVarFp
        .getByCarrierVisitId(carrierVisitId, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * IssuesApi - object-oriented interface
 */
export class IssuesApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getAll(options?: RawAxiosRequestConfig) {
    return IssuesApiFp(this.configuration)
      .getAll(options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} carrierVisitId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getByCarrierVisitId(carrierVisitId: number, options?: RawAxiosRequestConfig) {
    return IssuesApiFp(this.configuration)
      .getByCarrierVisitId(carrierVisitId, options)
      .then(request => request(this.axios, this.basePath))
  }
}
